"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PaginationBar;

var _react = _interopRequireDefault(require("react"));

require("./_style.scss");

var _reactSvg = require("react-svg");

var _CircleButton = _interopRequireDefault(require("../CircleButton/CircleButton"));

var _PrimaryText = _interopRequireDefault(require("../Text/PrimaryText"));

var _settings = _interopRequireDefault(require("../../settings"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

function PaginationBar(_ref) {
  var _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
      _ref$pageSizes = _ref.pageSizes,
      pageSizes = _ref$pageSizes === void 0 ? [5, 10, 25, 50, 100] : _ref$pageSizes,
      totalItems = _ref.totalItems,
      onPageChange = _ref.onPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      page = _ref.page,
      children = _ref.children,
      rest = _ref.rest;
  var totalPages = Math.ceil(totalItems / pageSize),
      index = page - 1,
      pageStart = index * pageSize + 1,
      pageEnd = Math.min(totalItems, pageStart + pageSize - 1);
  var canPreviousPage = page > 1;
  var canNextPage = page < totalPages;

  var goToPage = function goToPage(page) {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  var goToPreviousPage = function goToPreviousPage() {
    goToPage(Math.max(1, page - 1));
  };

  var goToNextPage = function goToNextPage() {
    goToPage(Math.min(totalPages, page + 1));
  };

  var pageSizeOptions = pageSizes.map(function (x) {
    return {
      key: x,
      value: x
    };
  });

  var pageSizeChange = function pageSizeChange(option) {
    if (onPageSizeChange) {
      onPageSizeChange(Number(option.value));
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", Object.assign({
    className: "nstyle-pb-pagination-bar"
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-pb__level"
  }, /*#__PURE__*/_react["default"].createElement(_CircleButton["default"], {
    onClick: goToPreviousPage,
    className: "nstyle-pb__previous ".concat(canPreviousPage ? '' : 'disabled')
  }, /*#__PURE__*/_react["default"].createElement(_reactSvg.ReactSVG, {
    src: _settings["default"].icons.arrow,
    className: "nstyle-pb__icon ".concat(canPreviousPage ? '' : 'disabled')
  })), /*#__PURE__*/_react["default"].createElement(_CircleButton["default"], {
    onClick: goToNextPage,
    className: "nstyle-pb__next ".concat(canNextPage ? '' : 'disabled')
  }, /*#__PURE__*/_react["default"].createElement(_reactSvg.ReactSVG, {
    src: _settings["default"].icons.arrow,
    className: "nstyle-pb__icon ".concat(canNextPage ? '' : 'disabled')
  })), /*#__PURE__*/_react["default"].createElement(_PrimaryText["default"], {
    className: "nstyle-pb__text nstyle-pb__text--page-summary"
  }, "Showing ".concat(pageStart, " - ").concat(pageEnd, " of ").concat(totalItems))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-pb__page-select"
  }, /*#__PURE__*/_react["default"].createElement(_PrimaryText["default"], {
    className: "nstyle-pb__text nstyle-pb__text--page-selector"
  }, "Items per page"), /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    value: pageSize,
    onOptionSelected: pageSizeChange,
    options: pageSizeOptions,
    className: "nstyle-pb__page-dropdown"
  })), children);
}